
export const servicesData = [
  {
    id: "traffic-control",
    title: "Temporary Traffic Control",
    imageSrc: "/lovable-uploads/be06cbde-d197-4393-8178-f69093d87d35.png",
    description: [
      "Traffic Control Supervisors (TCS)", 
      "Large & Small Projects", 
      "Overnight Operations"
    ],
    features: ["Expert Traffic Control Teams", "Comprehensive Safety Standards", "24/7 Availability"],
    fullDescription: "Our temporary traffic control services provide professional traffic management for construction sites, road repairs, and special events. We ensure the safety of both workers and the public with our expert traffic control teams."
  },
  {
    id: "traffic-control-plans",
    title: "Traffic Control Plans",
    imageSrc: "/lovable-uploads/00350358-404f-4a74-8213-c92223bb2140.png",
    description: [
      "ATSSA Certified Plan Designers", 
      "Satellite & Color Styles", 
      "72 Hour Delivery"
    ],
    features: ["MUTCD Compliant Plans", "Fast Turnaround", "Digital & Print Formats"],
    fullDescription: "Our certified designers create custom traffic control plans that meet all regulatory requirements. With quick turnaround times and various format options, we ensure your project stays on schedule."
  },
  {
    id: "certified-flaggers",
    title: "Certified Flaggers",
    imageSrc: "/lovable-uploads/03ec302d-31d4-468c-af2f-051446eb9475.png",
    description: [
      "Automated Flagging Devices", 
      "ATSSA Certified Flaggers", 
      "24/7 Availability"
    ],
    features: ["ATSSA Certified", "Proper PPE & Equipment", "Radio Communication"],
    fullDescription: "Our ATSSA certified flaggers are trained to manage traffic safely and efficiently. With proper equipment and constant communication, they ensure smooth traffic flow around your work zone."
  },
  {
    id: "event-services",
    title: "Event Management",
    imageSrc: "/lovable-uploads/53476ed8-236b-4a88-8c5d-3f7b229c8edf.png",
    description: [
      "Parking Lot Attendance", 
      "Vehicle Traffic Control",
      "Pedestrian Mitigation"
    ],
    features: ["Crowd Management", "Parking Solutions", "Emergency Access Routes"],
    fullDescription: "Our event management services help coordinate vehicle and pedestrian traffic for concerts, sporting events, and other large gatherings. We create comprehensive plans to ensure safe and efficient movement."
  },
  {
    id: "temporary-fencing",
    title: "Temporary Fencing",
    imageSrc: "/lovable-uploads/157941de-64f6-43a7-a97d-7e8ef9f359f3.png",
    description: ["Commercial & Residential", "Work Zone Fencing", "Privacy Screen"],
    features: ["Quick Installation", "Multiple Height Options", "Wind Screen Available"],
    fullDescription: "Our temporary fencing solutions provide security and boundary definition for construction sites and events. With various height options and privacy screens available, we can meet your specific needs."
  },
  {
    id: "on-call-emergency",
    title: "Custom Solutions",
    imageSrc: "/lovable-uploads/ed99ae9b-d1b4-45c6-84d8-127f856166ef.png",
    description: [
      "Long-term Project Collaboration",
      "Emergency & On-Call Service", 
      "Customized Client Billing"
    ],
    features: [
      "24/7 On-Call Service",
      "Immediate Crew Mobilization", 
      "Coordination with Law Enforcement & First Responders"
    ],
    fullDescription: "We offer customized traffic control solutions for unique situations and emergency scenarios. With 24/7 availability and rapid response times, we're ready whenever you need us."
  },
];
